import React, { useState, forwardRef, useImperativeHandle } from 'react'
import { Controller, SubmitHandler, useForm } from 'react-hook-form'

import { FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select } from '@material-ui/core'
import Swal from 'sweetalert2'

import Modal from '~/components/modal'
import { disapproved } from '~/constants/data-field'
import { submitDisapprovedResult } from '~/mappers/validation-mapper'
import { useValidationStore } from '~/store/validation/validation-store'
import { IResultsModalActionsDisapproved, IValidationSumary } from '~/types/validation-types'

import { useStyles } from './styles'

const ResultActionsModal: React.ForwardRefRenderFunction<IResultsModalActionsDisapproved> = (
  props,
  ref,
) => {
  const [modalComponenteState, setModalComponenteState] = useState<boolean>(false)
  const [submitDisapproved, setSubmitDisapproved] = useState<IValidationSumary>(
    {} as IValidationSumary,
  )

  const { isLoadingButton, client, disapprovedResults } = useValidationStore()

  useImperativeHandle(ref, () => {
    return {
      handleAction(validationDataParams: any) {
        setModalComponenteState(true)
        setSubmitDisapproved(validationDataParams)
      },
    }
  })
  const handleDisapprovedResult: SubmitHandler<any> = async (data) => {
    Swal.fire({
      icon: 'warning',
      title: 'Atenção',
      text: 'Tem certeza que deseja reprovar esse resultado?',
      confirmButtonColor: '#2b78c0',
      showCancelButton: true,
      cancelButtonColor: '#ff7d89',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não, cancele',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCloseButton: true,
      customClass: {
        container: 'alert-container',
      },
    }).then(async (result: any) => {
      if (result.isConfirmed) {
        setModalComponenteState(false)
        await disapprovedResults(
          submitDisapprovedResult(data, submitDisapproved, client?.cliente_id),
        )
      }
    })
  }

  const {
    control,
    formState: { errors },
    handleSubmit,
  } = useForm<any>()
  const classes = useStyles()

  return (
    <Modal
      onClose={() => {
        setModalComponenteState(false)
      }}
      open={modalComponenteState}
      isLoad={isLoadingButton}
      title="Reprovando Resultado"
      save
      onSave={handleSubmit(handleDisapprovedResult)}
    >
      <Grid container spacing={3} className={classes.modalStyle}>
        <Grid item sm={12}>
          <Controller
            name="reprova"
            control={control}
            defaultValue="1"
            render={({ field }) => (
              <FormControl variant="outlined" className={classes.selectInput}>
                <InputLabel id="reprova_id">Reprova</InputLabel>
                <Select
                  {...field}
                  labelId="reprova_label"
                  id="reprova_id"
                  label="reprova_id"
                  autoWidth
                  required
                  error={!!errors?.reprova}
                >
                  {disapproved.map((Option) => (
                    <MenuItem key={Option.value} value={Option.value}>
                      {Option.label}
                    </MenuItem>
                  ))}
                </Select>
                {errors.reprova?.message && (
                  <FormHelperText className={classes.helperText}>
                    {errors.reprova?.message}
                  </FormHelperText>
                )}
              </FormControl>
            )}
          />
        </Grid>
      </Grid>
    </Modal>
  )
}

export default forwardRef(ResultActionsModal)
